import GetArticlePreviewImageByIdRequestModelBase from '../_generated/modelBases/get-article-preview-image-by-id-request-model-base';

export default class GetArticlePreviewImageByIdRequestModel extends GetArticlePreviewImageByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
